import { fetchAPIWithID } from "../config";

export async function getMapItems(id, campsiteId) {
  let req = {};
  req.Guid = campsiteId;
  req.Type = id;
  const data = await fetchAPIWithID("/ssm_api_node/getmapits", req);
  return data;
}
